import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

export default Icon;
